<template>
  <div class="mobile-wrap">
    <div class="mobile-card">
      <div class="mobile-icon"><i class="fa fa-file-text"></i></div>
      <div class="mobile-title">Upload Request Letter</div>

      <template v-if="uploaded">
        <div class="state-box state-box--success">
          <i class="fa fa-check-circle"></i>
          <p>Request letter uploaded successfully. You can close this page.</p>
        </div>
      </template>

      <template v-else>
        <p class="mobile-sub">Tap below and choose <strong>Scan Documents</strong> from the menu if your phone offers it, for the best quality scan.</p>

        <label class="file-drop">
          <input type="file" accept="image/*,application/pdf" @change="onFileChange" />
          <i class="fa fa-file-text-o"></i>
          <span>{{ fileName || 'Tap to scan or choose a document' }}</span>
        </label>

        <div class="state-box state-box--error" v-if="errorMsg">
          <i class="fa fa-exclamation-circle"></i>
          <p>{{ errorMsg }}</p>
        </div>

        <button class="upload-btn" :disabled="!file || uploading" @click="upload">
          <span v-if="uploading" class="spinner"></span>
          <span v-else><i class="fa fa-upload"></i> Upload</span>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { UPLOAD_REQUEST_LETTER_MOBILE } from "@/core/services/store/actions.type";
import { resizeImageFile } from "@/core/services/imageresize";

export default {
  data() {
    return {
      file: null,
      fileName: "",
      uploading: false,
      uploaded: false,
      errorMsg: ""
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.file = file;
      this.fileName = file.name;
      this.errorMsg = "";
    },
    upload() {
      this.uploading = true;
      this.errorMsg = "";
      resizeImageFile(this.file).then(file => {
        this.$store
          .dispatch(UPLOAD_REQUEST_LETTER_MOBILE, {
            token: this.$route.params.token,
            file
          })
          .then(() => {
            this.uploading = false;
            this.uploaded = true;
          })
          .catch(err => {
            this.uploading = false;
            this.errorMsg = (err && err.msg) || "Upload failed. The link may have expired.";
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.mobile-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f7fc;
  padding: 24px 16px;
  font-family: $font;
}

.mobile-card {
  width: 100%;
  max-width: 380px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(13, 27, 62, 0.1);
}

.mobile-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, $blue, #2277aa);
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.mobile-title { font-size: 17px; font-weight: 700; color: $dark; margin-bottom: 6px; }
.mobile-sub { font-size: 13px; color: #7a8499; margin-bottom: 20px; }

.file-drop {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border: 2px dashed $border;
  border-radius: 12px;
  padding: 28px 16px;
  cursor: pointer;
  color: #7a8499;
  font-size: 13px;
  margin-bottom: 16px;
  transition: border-color 0.2s;

  input { display: none; }
  i { font-size: 26px; color: $blue; }

  &:hover { border-color: $blue; }
}

.upload-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: $blue;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.15s;

  &:disabled { opacity: 0.5; cursor: default; }
  &:hover:not(:disabled) { background: #2d85bb; }
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2.5px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin { to { transform: rotate(360deg); } }

.state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-radius: 10px;
  font-size: 13px;
  margin-bottom: 16px;

  i { font-size: 26px; }
  p { margin: 0; }

  &--success { background: #f0fff4; color: #276749; }
  &--error { background: #fff5f5; color: #c53030; }
}
</style>
